import React from "react";

// Always-visible marker so a preview build can never be mistaken for the real
// portal. Rendered only in preview builds (caller guards on PREVIEW_MODE).
// pointerEvents:none so it never blocks a click on the page underneath.
export default function PreviewModeBanner() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "#b45309",
        color: "#fff",
        font: "600 12px/20px system-ui, -apple-system, sans-serif",
        textAlign: "center",
        letterSpacing: "0.04em",
        padding: "2px 8px",
        pointerEvents: "none",
      }}
    >
      PREVIEW MODE — mock session &amp; sample data, not real data
    </div>
  );
}
